import Link from "next/link";

/** Shown under a post when a non-member tries to comment or react. */
export function PostJoinPrompt({ groupSlug, onClose }: { groupSlug: string; onClose: () => void }) {
  return (
    <div className="mx-4 mb-3">
      <div className="bg-primary-muted/40 border border-indigo-200 dark:border-indigo-800 rounded-xl p-4 flex items-start justify-between gap-3">
        <div>
          <p className="text-sm font-medium text-indigo-900 dark:text-indigo-100">Kun medlemmer kan skrive</p>
          <p className="text-xs text-primary-muted-foreground mt-0.5">Bliv medlem af gruppen for at kommentere og reagere på opslag.</p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Link
            href={`/grupper/${groupSlug}`}
            className="px-3 py-1.5 rounded-lg text-xs font-medium bg-indigo-600 text-white hover:bg-indigo-700 transition-colors"
          >
            Anmod om medlemskab
          </Link>
          <button
            type="button"
            onClick={onClose}
            className="text-indigo-400 hover:text-indigo-600 dark:hover:text-indigo-300 transition-colors"
            aria-label="Luk"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
